import { schema } from 'normalizr';

export const clientsUserSchema = new schema.Entity('users');

export const clientsUsersSchema = new schema.Array(clientsUserSchema);
